import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "next--sprite",
  "use": "next--sprite-usage",
  "viewBox": "0 0 4 8",
  "content": "<symbol viewBox=\"0 0 4 8\" xmlns=\"http://www.w3.org/2000/svg\" id=\"next--sprite\">\n<path d=\"M0.333496 7.33329L3.66683 3.99996L0.333496 0.666626V7.33329Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol